<div class="e-page-break" *ngIf="multiplePages">
    <span>{{rangeStart}}-{{rangeEnd}} of {{totalSize}}</span>
</div>
